<template>

<!-- 租户使用模块可以操作撤销 -->
    <section>
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
				<el-form-item>
					<el-input v-model="filters.CardNumber" @keyup.enter.native="Consumption" placeholder="会员卡号
                    "></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="Consumption"  icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="ConsumptionBusiness">刷卡消费</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="ShowOver">结束刷卡</el-button>
				</el-form-item>				
				<el-form-item>
					<el-button type="warning" @click="Authorization()">授权注销设备</el-button>
				</el-form-item>				 -->
			</el-form>
		</el-col>
	<!--列表-->
		<el-table :data="Consumptions" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" :default-sort = "{prop: 'CreationTime', order: 'descending'}">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="CardNumber" label="卡号" width="150" sortable>
			</el-table-column>			
			<el-table-column prop="ConsumptionType" label="卡类型" width="100" :formatter="formatType" sortable>
			</el-table-column>
			<el-table-column prop="MemberName" label="会员名称" width="150" sortable>
			</el-table-column>
		    <!-- <el-table-column prop="CoachName" label="教练名称" width="150" sortable>
			</el-table-column> -->
			<el-table-column prop="ComboName" label="消费套餐项目" width="200" sortable>
			</el-table-column>
			<el-table-column prop="CreationTime" label="消费时间" width="200"  sortable>
			</el-table-column>	
			<el-table-column prop="Frequency" label="消费量" width="150" sortable>
			</el-table-column>	
			<el-table-column prop="Amount" label="消费金额" width="150" sortable>
			</el-table-column>	
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="State" label="消费状态" width="120" sortable fixed="right">				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State==1">已撤销</el-tag>
                  <el-tag type="success" size="medium" v-else>正常</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column label="操作" width="150" fixed="right">
				<template  slot-scope="scope">
                    <!-- 两小时可撤单 -->
					<el-button type="danger" size="small" @click="Cancel(scope.$index, scope.row)">撤单</el-button>
				</template>
			</el-table-column>
		</el-table>
        	<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
    <el-dialog  title="请检查读卡器是否连接" custom-class style="width:100%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;"  v-model="Machine" :close-on-click-modal="false">
     <el-row >
      <el-col :span="25" >
      <el-card :body-style="{ padding: '0px'  }">
      <div >     
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
        <!-- <span>请检查读卡器</span> -->	
				<el-form-item >
					<input class="input" style="width:180px" ref="siteInput"  v-model="basicCard"  clearable @keyup.enter="FindCard" :autofocus="focusvalue" placeholder="卡号"></input>
				</el-form-item>
				<el-form-item >
					<el-input style="width:120px"  v-model="inputPhone"  clearable    placeholder="手机号码"></el-input>
				</el-form-item>
				<el-form-item >
					<el-input style="width:120px"  v-model="inputName"  clearable   placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button  type="primary" v-on:click="FindCard" icon="el-icon-search">查找业务卡</el-button>
				</el-form-item>	
				<!-- <el-form-item>
                    <el-button type="warning" @click="Authorization()">授权注销设备</el-button>					
				</el-form-item>	 -->
																
			</el-form>			
		</el-col>		 				 						
      </div>	  
      </div>
      </el-card>
     </el-col>
     </el-row>	
	 <el-row style="width: 100%">
   <el-table :data='tableData' >
    <el-table-column 
      label="卡号"
	  prop="CardNumber"
      width="160px ">
    </el-table-column>
	<el-table-column 	
      label="姓名" prop="Name"
      width="130px ">
    </el-table-column>
    <el-table-column  :formatter="CardType"
      prop="CardType"
      label="卡类型"
      width="88px ">
    </el-table-column>  
    <el-table-column
      prop="ComboName"
      label="套餐"
      min-width="180">
    </el-table-column> 
    <!-- <el-table-column
      prop="CoachName"
      label="教练名称"
      min-width="120">
    </el-table-column>  -->
	  
    <el-table-column
      prop="CreationTime"
      label="办理时间"
      min-width="180">
    </el-table-column>   
    <el-table-column fixed="right"
      label="操作"
      width="88px ">
      <template slot-scope="scope">
        <el-button v-if="scope.row.State==1" type="danger"  size="small">已停用</el-button>
        <el-button v-else @click="handleClick(scope.row)" type="success" size="small">消费</el-button>
      </template>
    </el-table-column>
  </el-table>
  	<el-col :span="24" class="toolbar">
			<el-tag>当前有{{Count}}条业务卡</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="10" :total="mebtotal" style="float:right;">
			</el-pagination>
	</el-col>
	 </el-row>
    </el-dialog>
        <el-dialog title="查看大图" v-model="seeImageVisible">
			<img   :src="imgUrl" style="height: 100%; width: 100%; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; ">
		</el-dialog>	
       	<el-dialog title="会员消费信息"  v-model="ConsumptionVisible" :close-on-click-modal="false" @close='closeDialog'>
		   <el-row  >
			   <el-col :span="18" >
		    <el-form :model="ConsumptionData"  label-width="130px"  ref="ConsumptionData" @submit.native.prevent  class="demo-form-inline" @submit.native.prevent> 				
				<el-form-item label="卡号姓名">
					<el-input  v-model="ConsumptionData.CardNumber"  auto-complete="off" style="width:49%"></el-input>
					<el-input v-model="ConsumptionData.MemberName"  auto-complete="off" style="width:49%"></el-input>
				</el-form-item>
				<el-form-item label="卡类型套餐">
					<el-input style="width:49%" v-model="ConsumptionData.CardType== '0' ? '次卡' : ConsumptionData.CardType == '1' ? '月卡' : ConsumptionData.CardType == '2' ? '年卡': ConsumptionData.CardType == '3' ? '充值卡': ConsumptionData.CardType == '4' ? '培训卡': ConsumptionData.CardType=='5'?'业主卡':'未知'"  auto-complete="off" ></el-input>
					<el-input style="width:49%" v-model="ConsumptionData.ComboName" auto-complete="off"></el-input>
				</el-form-item>
					<div v-if="ConsumptionData.CardType=='3'||ConsumptionData.CardType=='5'">
 				<el-form-item label="消费金额-剩余余额">
					<el-input v-model="ConsumptionData.ConsumptionMoney"  auto-complete="off" style="width:49%"></el-input>
					<el-input v-if="ConsumptionData.Tips==true" v-model="ConsumptionData.Balance"  auto-complete="off" style="width:49%;border:solid 1px red;border-radius: 4px; " ></el-input>
					<el-input v-else v-model="ConsumptionData.Balance"  auto-complete="off" style="width:49%"></el-input>
				</el-form-item>  
				<el-form-item label="消费数量">
					<el-input  style="width:49%"  v-model="RechargeableConsumptionFrequency"  @keyup.enter.native="RechargeableConsumptionSubmit" clearable  :autofocus="RechargeableConsumptionFocusvalue" placeholder="次数"></el-input>
				<el-select  placeholder v-model="RechargeableConsumption" placeholder="请选择项目" clearable filterable style="width:49%">
                <el-option
                  v-for="item in options"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id" >
                </el-option>
                 </el-select>
				</el-form-item>						 				 
				</div>
				<span v-for="item in ConsumptionData.ErrMsgList" v-if="ConsumptionData.State==true" style="border:20px;"> 
					<el-alert title=""  type="success" :closable="false">{{item}}</el-alert>				 				
                </span>	
				<span v-for="item in ConsumptionData.ErrMsgList" v-if="ConsumptionData.State==false"> 
				<el-alert title=""  type="error" :closable="false">{{item}}</el-alert>				 				
                </span>				            
			</el-form>
			   </el-col>
			   <el-col :span="4" style="padding-left: 10px">
				   <div>
				   <el-form>
					   <el-form-item >
				<span v-for="item in ConsumptionData.ImageList"  style="border:20px;"> 
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img   @click="see(item)"  :src="image(item)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>   
					</br>									
                </span>	
					   </el-form-item>
				   </el-form>
				   </div>				  
			   </el-col>
		   </el-row>
				 <br>		
				<el-button :autofocus="true" style="float: left"  v-if="ConsumptionData.State==true" type="primary" @click.native="Confirm(ConsumptionData.CardType)" :loading="ConsumptionConfirm">确认消费</el-button>
		     	<br>
				 <span v-if="ConsumptionData.CardType=='3'||ConsumptionData.CardType=='1'||ConsumptionData.CardType=='2'&&ConsumptionData.ImageList.length>0">
					<br>
					<br>
					<br>
					<br>
					<br>
					<br>
					<br>
				</span>	
		</el-dialog>
    <el-dialog  title="结束业务刷卡记录"  v-model="OverVisible" :close-on-click-modal="false" @submit.native.prevent  >
     <el-row >
      <el-col :span="25" >
      <el-card :body-style="{ padding: '0px'  }">
         <div >      
          	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
				<el-form-item >
					<input class="input" ref="siteInput3"  v-model="CardNumber"  @click.native="Over"  :autofocus="focusvalue" placeholder="卡号"></input>
				</el-form-item>
				<el-form-item >
					<el-input style="width:120px"  v-model="OverPhone"  clearable    placeholder="手机号码"></el-input>
				</el-form-item>
				<el-form-item >
					<el-input style="width:120px"  v-model="OverName"  clearable   placeholder="姓名"></el-input>
				</el-form-item>				
				<el-form-item>
					<el-button  type="primary" v-on:click="FindOverCard" icon="el-icon-search">查找物理卡</el-button>
				</el-form-item>					
				<el-form-item>
					<el-button  type="primary" v-on:click="Over" icon="el-icon-search">确认刷卡</el-button>
				</el-form-item>							
			</el-form>	
	    	 </el-col>
		 </div>
	  </el-card>
     </el-col>
    </el-row>
		 <el-row style="width: 100%">
   <el-table :data='OverData' >
    <el-table-column 
      label="卡号"
	  prop="CardNumber"
      width="160px ">
    </el-table-column>
	<el-table-column 	
      label="姓名" prop="Name"
      width="130px ">
    </el-table-column>  
    <el-table-column
      prop="CreationTime"
      label="开卡时间"
      min-width="180">
    </el-table-column>   
    <el-table-column fixed="right"
      label="操作"
     min-width="28px ">
      <template slot-scope="scope">
        <el-button  @click="handleOverClick(scope.row)" type="success" size="small">选择</el-button>
      </template>
    </el-table-column>
  </el-table>
  	<el-col :span="24" class="toolbar">
			<el-tag>当前有{{OverCount}}张物理卡</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="Overtotal" style="float:right;">
			</el-pagination>
	</el-col>
	 </el-row>
    </el-dialog>		
    <el-dialog  title="授权进场"  v-model="AuthorizationVisible" :close-on-click-modal="false" @submit.native.prevent  >
     <el-row >
      <el-col :span="25" >
      <el-card :body-style="{ padding: '0px'  }">
         <div >      
          	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
				<el-form-item >
					<input class="input" ref="siteInput2"  v-model="AuthorizationNumber"  @click.native="ConfirmAuthorization"  :autofocus="focusvalue" placeholder="设备识别编号"></input>
				</el-form-item>
				 <!-- clearable @keyup.enter="BusinessHandle" -->
				<el-form-item>
					<el-button  type="primary" v-on:click="ConfirmAuthorization" icon="el-icon-search">确认授权</el-button>
				</el-form-item>	
				<el-form-item>
                    <el-button type="danger" @click="CancelAuthorization()">注销授权</el-button>					
				</el-form-item>								
			</el-form>	
	    	 </el-col>
            <el-col>
				<el-form  label-width="120px"  ref="addForm">
				<el-form-item label="名字" prop="Name">
					<el-input v-model="AuthorizationModel.Name" auto-complete="off"></el-input>
				</el-form-item>				
			    <el-form-item label="手机号码" prop="Telephone">
					<el-input  v-model="AuthorizationModel.Telephone" auto-complete="off"></el-input>
				</el-form-item>		
			    <el-form-item label="身份证号码" prop="IdCard">
					<el-input  v-model="AuthorizationModel.IdCard" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="AuthorizationModel.Remark"></el-input>
				</el-form-item>		
				<br>			
 			    <el-form-item label="图片信息" >
					<!-- <el-input  v-model="AuthorizationModel.ImageUrl" auto-complete="off"></el-input> -->
<el-upload 
  action="#" :http-request="upload" 
  :file-list="fileList"
  list-type="picture-card"
  :on-preview="handlePictureCardPreview"
  :before-upload="beforeAvatarUpload"
  :on-remove="handleRemove"
  >
  <i class="el-icon-plus"></i>
</el-upload>					
				</el-form-item>               		
			<br>
			<br>			<br>
			<br>		
			</el-form>		
			<br>
			<br>
			<br>
			</el-col>
        </div>
      </div>
      </el-card>
      </el-col>
      </el-row>	
	</el-dialog>

	    	<el-dialog :visible.sync="dialogVisible">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
    </section>
</template>
<script>
import util from '../../common/js/util'
import {getbasicListPage,addRecord,Upload,CancelPreparations,PreparationsCreate,OneCardMemberState,OneCardConsumptionPage,OwnerCardConsumption,getMemberList,OneCardConsumptionData,TrainingCardConsumption,OneCardCancelConsumption,OneCardOptionsList,OneCardPage,FrequencyCardConsumption,MonthCardConsumption,YearCardConsumption,OneCardConsumption} from '../../api/api';
import ConsumptionsCard from "../../assets/images/ConsumptionsCard.png"
import {mapState, mapMutations,mapGetters, mapActions} from 'vuex';

export default { 
  data(){
      return{
		  overpage:1,
          OverData:[],
		  OverCount:0,
		  Overtotal:0,
		  OverVisible:false,
		  CardNumber:'',
		  OverName:'',
		  OverPhone:'',   
		//  授权相关
		dialogVisible:false,
		dialogImageUrl:'',
		            fileList:[],
		AuthorizationModel:{
			//授权设备号
			CardNumber:'',
			BasicId:'',
			CustomerType:1,
			ConsumptionId:'',
			MemberId:'',
			Name:'',
			Telephone:'',
			IdCard:'',
			ImageUrl:'',
			Remark:''
		},
		CurrentBasicId:'',
		AuthorizationVisible:false,
        AuthorizationNumber:'',
		  shopInfo:{},
		   //手机号查找卡
		  tableData:[
		 ],	
		 businessId:'',
		 		seeImageVisible:false,
				imgUrl:'',
				UploadImageUrl:'',
				imageVisible:false,		   
		  //消费展示数据
		  ConsumptionResult:false,
		  ConsumptionVisible:false,
		  ConsumptionConfirm:false,		  
		//   ConsumptionTitle:'',
		  ConsumptionData:{},
		  //分页
			//充值卡消费项目			
				RechargeableConsumption:'',
                RechargeableConsumptionFrequency:1,			
			ConsumptionRules:{
				 RechargeableConsumption:[{required: true, message: '请选择消费项目', trigger: 'change'  }]
		      	},
			options:[],
		   RechargeableConsumptionVisible:false,
		   RechargeableConsumptionId:'',
		   RechargeableConsumptionFocusvalue:false,
			  //会员id相关
			  Id:'',
            //次卡相关模型 视图 属性等等 消费次数
			FrequencyCardVisible:false,
			Frequency:1,
			// FrequencyFocusvalue:false,/
           //卡类型
            businessTitle:'',
          ConsumptionsCard:ConsumptionsCard,
		  //取卡器相关设置
		  focusvalue:false,
		  inputPhone:'',
		  inputName:'',
		  inputIdCard:'',
		  Machine:false,
          filters:{
			   CardNumber:'',
			  
          },
          Consumptions:[],        			
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],//列表选中列	
				
		//
		mebpage:1,
		mebtotal:0,
		Count:0,
		basicCard:'',		
        }
  },
 methods: {
	 handleOverClick(row){
		  this.CardNumber=row.CardNumber;
		  this.Over();
	 },
	 FindOverCard(){
				let para = {
					PageIndex: this.overpage-1,					
					PageSize:10,
					Name:this.OverName,
					IcCard:this.CardNumber,
					Telephone:this.OverPhone,

				};
				this.listLoading = true;
				getbasicListPage(para).then((res) => {
					this.Overtotal = res.data.TotleCount;
					this.OverData =res.data.Data;
                    this.OverCount=res.data.TotleCount;
					this.listLoading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });	 },
	 	 		...mapGetters(['getshopInfo']),	
	 ShowOver(){
		 this.OverVisible=true;
		 this.OverData=[];
		 this.OverName='';
		 this.OverPhone='';
		 this.CardNumber='';
		 	this.$nextTick(function(){
			  this.$refs['siteInput3'].focus();
			  })

	 },
	 Over(){
		   
			  let para= {
				  CardNumber:this.CardNumber
			  };
			  	addRecord(para).then((res) => {
					  						//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									this.OverVisible=false;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								    });
								}
					}).catch(() => {
				});			   
	 },
     msgShow(bool,msg){
        if(bool)
        {
                 this.$message({
                  message: msg,
                  type: 'success'
                });
        }else
        {
                 this.$message({
                  message: msg,
                  type: 'error'
                });
        }
       
      },	 
     upload(param)
			{
			    var fileObj=param.file;
				var fd=new FormData();
				fd.append("file",fileObj);

			  	Upload(fd).then((res)=>{
					  
					  
								let { Success,Msg } = res.data;
                               if (!Success) {
                               this.msgShow(false,"上传失败");
                                } else {
									this.AuthorizationModel.ImageUrl=res.data.Data;
									console.log("---"+this.AuthorizationModel.ImageUrl);
								this.msgShow(true,"上传成功");}				              
			  }).catch(error=>{
                 alert('网络错误');
                });
            },  	 
        handlePictureCardPreview(file) {
		  console.log("image view");
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }	,	 
       	 beforeAvatarUpload(file) {

// 		 console.log("befor2");
// 		  if(this.uploadlimit==0)
// 		   {
//                this.uploadlimit=this.uploadlimit+1;
//                console.log(this.uploadlimit);
// 			  return true;
// 		   }
// 		   if(this.uploadlimit==1)
// 		   {
// 			 this.msgShow(false,"当前只支持上传一张");
// console.log(this.uploadlimit);
//      		 return false;
//            }
           

      },
 	      handleRemove(file, fileList) {
         
        //  if(fileList.lenght>)
		// this.uploadlimit=this.uploadlimit-1;
        // console.log( this.uploadlimit);
	  },	
      	 
	    CancelAuthorization(){
			
			  let para= {
				  cardNumber:this.AuthorizationNumber
			  };
			  	CancelPreparations(para).then((res) => {
					  						//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									// this.AuthorizationVisible=false;
									// this.onCellClick(event);
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								    });
								}
					}).catch(() => {
				});				
	    },
	    ConfirmAuthorization(){
			if(this.AuthorizationNumber=='')
			{
						this.$message({
							message: '请输入授权设备',
							type: 'error'
						});	
						return;			
			}
			  this.AuthorizationModel.CardNumber=this.AuthorizationNumber;
			  let para= Object.assign({}, this.AuthorizationModel);
			  	PreparationsCreate(para).then((res) => {
					  						//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									this.AuthorizationVisible=false;
									if(this.AuthorizationModel.CustomerType==0)
									{
									this.onCellClick(event);
									} 
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								    });
								}
					}).catch(() => {
				});			
		},
		AuthorizationFocus(){
			 this.$nextTick(function(){
			  this.$refs['siteInput2'].focus();
			  })
		},
	       Authorization(){
			this.AuthorizationNumber='';   	 
			this.AuthorizationModel.Name='';
			this.AuthorizationModel.Telephone='';
			this.AuthorizationModel.IdCard='';
			this.AuthorizationModel.ImageUrl='';
			this.AuthorizationModel.Remark='';
          

				   this.AuthorizationVisible=true;
	               this.AuthorizationFocus();		 
			
          // this.$(event.target).children().find("input").focus();                            
		   },
		 ConsumptionAuthorization(value)
		   {
			this.AuthorizationNumber='';   	 
			    //  console.log("11");						
			   	   console.log(value);
		    this.AuthorizationModel={
			//授权设备号
			CardNumber:'',
			BasicId:'',
			MemberId:'',
			CustomerType:1,
			ConsumptionId:'',
			MemberId:'',
			Name:'',
			Telephone:'',
			IdCard:'',
			ImageUrl:'',
			Remark:''			
	       	}
			 this.AuthorizationModel.CustomerType=0;
			 this.AuthorizationModel.ConsumptionId=value.Id;
			this.AuthorizationModel.MemberId=value.MemberId;
			this.AuthorizationModel.BasicId=this.CurrentBasicId;
			console.log(this.CurrentBasicId);
			   	// if(this.shopInfo.MachineState!=0)
				//  {
				// 	//半智能
				// 	//   if(this.shopInfo.MachineState==2)
				// 	//   {

				// 	//   }
				// 	//   //全智能
				// 	//   if(this.shopInfo.MachineState==1)
				// 	//   {

				// 	//   }
				// 	this.AuthorizationVisible=true;
                //    this.AuthorizationFocus();													
				// }
				var mtState=this.getshopInfo().MachineState;
				console.log();
				
			 if(mtState==''||mtState==0)
			 {
			   this.AuthorizationVisible=false;

			 }
			 else
			 {
				   this.AuthorizationVisible=true;
	               this.AuthorizationFocus();		 
			 }
		   },
          handleCurrentChange2(val) {
                this.mebpage = val;
                this.FindCard();
            },
          handleCurrentChange3(val) {
                this.overpage = val;
                this.FindOverCard();
            },
		  image(imageStr)
		  {
			let  imgUrl=imageStr;
              return imgUrl;
		  },	
		  			see(Image){
                     this.imgUrl=Image;
                  this.seeImageVisible=true;
              },
    closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
    //   console.log(33);
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
         handleClick(row){
		   this.inputIdCard=row["CardNumber"];
		   this.businessId=row["Id"];
		   this.BusinessHandle();
		 },
	    Confirm(CardType)
	     {       
			 this.ConsumptionConfirm=true;
			 			switch(CardType)
							  {
								  //次卡消费
								  case '0':
								  {
									this.ConsumptionConfirm=false;									
										  this.FrequencySubmit();
								   break;
								  }
								  //月卡消费
								  case '1':
								  {
									  	 this.ConsumptionConfirm=false;
										  this.ConsumptionVisible=false;
									  let para={
										  IcCard:this.inputIdCard,
										  Id:this.Id,
										  ConsumptionTime:new Date()
									  }
									  MonthCardConsumption(para).then((res)=>{
										 this.inputIdCard='';
										let { Success,Msg } = res.data;
										// console.log(res.data);
										if(Success)
										{
											this.focusvalue=true;
											// console.log('---'+this.ConsumptionResult);
                                         this.$message({
				                            message: Msg,
				                         	type: 'success'
			                              	});
  											this.ConsumptionAuthorization(res.data.Data);

										}
										else
										{
                                         this.$message({
				                            message: Msg,
				                         	type: 'error'
			                              	});
  
										}
                                      
									  }).catch(error=>{
                                      alert('网络错误');
									  });
								   break;

								  }
								  //年卡消费
								  case '2':
								  {								
									      this.ConsumptionConfirm=false;
										  this.ConsumptionVisible=false;
									  let para={
										  IcCard:this.inputIdCard,
										  Id:this.Id,
										  ConsumptionTime:new Date()
									  }
									  YearCardConsumption(para).then((res)=>{
			 				         	this.inputIdCard='';
 										let { Success,Msg } = res.data;
										if(Success)
										{
                                         this.$message({
				                            message: Msg,
				                         	type: 'success'
											  });
  											this.ConsumptionAuthorization(res.data.Data);
											  
										}
										else
										{
                                         this.$message({
				                            message: Msg,
				                         	type: 'error'
			                              	}); 
										}                                     							  
									  }).catch(error=>{
                                      alert('网络错误');
                                      });
								   break;								  
								  }
								  //充值卡消费
								  case '3':
								  {									
                                             this.ConsumptionSubmit();
                                    //   this.RechargeableConsumption='';
						              this.RechargeableConsumptionFrequency=1;
								   break;									  
								  }
								  //培训咯消费
								  case '4':
								  {
									      this.ConsumptionConfirm=false;
										  this.ConsumptionVisible=false;                                 
                                   let para={
										  IcCard:this.inputIdCard,
										  Id:this.Id,
										  ConsumptionTime:new Date()
									  }
                                      TrainingCardConsumption(para).then((res)=>{
										  this.inputIdCard='';
										 
 										let { Success,Msg } = res.data;
										if(Success)
										{
  											this.ConsumptionAuthorization(res.data.Data);
                                         this.$message({
				                            message: Msg,
				                         	type: 'success'
			                              	});
										}
										else
										{
                                         this.$message({
				                            message: Msg,
				                         	type: 'error'
			                              	}); 
										}                                     							                                         
									  }).catch(error=>{
										  alert('网络错误');
									  })                                   
								   break;
								  }
								  case '5':
								  {
									    this.OwnerCardSubmit();
                                    //   this.RechargeableConsumption='';
						              this.RechargeableConsumptionFrequency=1;
								   break;									  
									  break;
								  }
								  default:
							  }
							  this.basicCard='';
							  this.tableData=[];
							  console.log(this.ConsumptionResult);
                    			this.onCellClick(event);				  
							  
		 },
	  //消费提交
      
       OwnerCardSubmit(){		
					//   console.log(this.RechargeableConsumption+' '+this.RechargeableConsumptionFrequency);
					 let para={
						 MemberId:this.Id,
						 CardNumber:this.inputIdCard,
						 ComboId:this.RechargeableConsumption,
						 Quantity:this.RechargeableConsumptionFrequency,
						 ConsumptionTime:Date.now()
					 }

				if(para.ComboId=='')
				{
					this.$message({
				    message: '请选择消费项目',
					type: 'error'
					 });
					this.ConsumptionConfirm=false;
				}
				else
				{
					para.ConsumptionTime= (!para.ConsumptionTime || para.ConsumptionTime == '') ? '' : util.formatDate.format(new Date(para.ConsumptionTime), 'yyyy-MM-dd hh:mm:dd');
               OwnerCardConsumption(para).then((res)=>{
			          	let { Success,Msg } = res.data;
			   if(Success)
	      			 {
                    this.$message({
				    message: Msg,
					type: 'success'
					 });
					 this.RechargeableConsumption='';
					 this.RechargeableConsumptionFrequency=1;
				  this.ConsumptionConfirm=false;
				  this.ConsumptionVisible=false;
				  this.inputIdCard='';
  				this.ConsumptionAuthorization(res.data.Data);
				 }
				 else
				 {
                    this.$message({
				    message: Msg,
					type: 'error'
			     	});
					//  this.RechargeableConsumption='';
					 this.RechargeableConsumptionFrequency=1;
				   	 this.ConsumptionConfirm=false;

			     }

					 }).catch(error=>{
                     alert('网络错误');
                   })


				}
					
			},
	  ConsumptionSubmit(){		
					//   console.log(this.RechargeableConsumption+' '+this.RechargeableConsumptionFrequency);
					 let para={
						 MemberId:this.Id,
						 CardNumber:this.inputIdCard,
						 ComboId:this.RechargeableConsumption,
						 Quantity:this.RechargeableConsumptionFrequency,
						 ConsumptionTime:Date.now()
					 }

				if(para.ComboId=='')
				{
					this.$message({
				    message: '请选择消费项目',
					type: 'error'
					 });
					this.ConsumptionConfirm=false;
				}
				else
				{
					para.ConsumptionTime= (!para.ConsumptionTime || para.ConsumptionTime == '') ? '' : util.formatDate.format(new Date(para.ConsumptionTime), 'yyyy-MM-dd hh:mm:dd');
               OneCardConsumption(para).then((res)=>{
			          	let { Success,Msg } = res.data;
			   if(Success)
	      			 {
                    this.$message({
				    message: Msg,
					type: 'success'
					 });
					 this.RechargeableConsumption='';
					 this.RechargeableConsumptionFrequency=1;
				  this.ConsumptionConfirm=false;
				  this.ConsumptionVisible=false;
				  this.inputIdCard='';
  				// this.ConsumptionAuthorization(res.data.Data);
				 }
				 else
				 {
                    this.$message({
				    message: Msg,
					type: 'error'
			     	});
					//  this.RechargeableConsumption='';
					 this.RechargeableConsumptionFrequency=1;
				   	 this.ConsumptionConfirm=false;

			     }

					 }).catch(error=>{
                     alert('网络错误');
                   })


				}
					
			},
	        FrequencySubmit(){
				// console.log(this.inputIdCard);
				let para={
                    IcCard:this.inputIdCard,
					Frequency:this.Frequency,
					ConsumptionTime:Date.now(),
					MemberId:this.Id,
				}
			   para.ConsumptionTime= (!para.ConsumptionTime || para.ConsumptionTime == '') ? '' : util.formatDate.format(new Date(para.ConsumptionTime), 'yyyy-MM-dd hh:mm:dd');

				if(this.Frequency<1)
				{
                    this.$message({
				    message: '消费次数不能小于一次',
					type: 'error'
					 });
					 this.Frequency=1;
					 this.ConsumptionConfirm=false;
				}
				else
				{
               FrequencyCardConsumption(para).then((res)=>{
				
				let { Success,Msg } = res.data;
				 if(Success)
				 {
                    this.$message({
				    message: Msg,
					type: 'success'
					 });
					 this.Frequency=1;
				//    this.FrequencyCardVisible=false;
				   this.ConsumptionVisible=false;
				   this.inputIdCard='';
  				   this.ConsumptionAuthorization(res.data.Data);
				 }
				 else
				 {
                    this.$message({
				    message: Msg,
					type: 'error'
			     	});
 				   this.Frequency=1;
                   this.ConsumptionConfirm=false;
			     }
                //   console.log(res);
                    
				}).catch(error=>{
                     alert('网络错误');
                })
				}

			  },
			  ...mapGetters(['getuserstate']),
			  FindCard(){
				  
				  let para={
					  PageIndex: this.mebpage-1,					
					  PageSize:10,
					  Telephone:this.inputPhone,
					  Name:this.inputName,
					  IcCard:this.basicCard
				  }		
                    OneCardConsumptionPage(para).then((response)=>{
						// console.log(response);
						this.tableData=response.data.Data;
						this.mebtotal = response.data.TotleCount;
                        this.Count=response.data.TotleCount;
					}).catch(error=>{
                                alert('网络错误消费数据获取失败');
                 });
			  },
      BusinessHandle(){
		
                if(this.businessId=='')
                {
                    this.$message({
				    message: '请选择业务卡',
					type: 'error'
			     	});
                }
                else
                {

                  let para={
                    Id:this.businessId,
                    TenancyId:JSON.parse(this.getuserstate()).TenancyId,
					}
				
				   OneCardMemberState(para).then((response)=>{
					let { Success,Msg } = response.data;
					
						this.ConsumptionConfirm=false;
						if(Success)
						{   
						    let Member=JSON.parse(response.data.JsonData);
							let CardType=Member.CardType;
							this.Id=Member.Id;
							this.CurrentBasicId=Member.BasicInformationId;	
							let para={
								Id:this.Id,
								ConsumptionTime:Date.now()
							}				
							para.ConsumptionTime= (!para.ConsumptionTime || para.ConsumptionTime == '') ? '' : util.formatDate.format(new Date(para.ConsumptionTime), 'yyyy-MM-dd hh:mm:dd');
                            OneCardConsumptionData(para).then(res=>{
									console.log(res);
									let { Success,Msg } = res.data;
									if(Success)
									{
									this.focusvalue=false;
									this.ConsumptionData=res.data.Data;
									this.ConsumptionVisible=true;
									// console.log(this.ConsumptionVisible);
									if(this.ConsumptionData.CardType=='3'||this.ConsumptionData.CardType=='5')
									{
									  OneCardOptionsList().then((res=>{
                                          this.options=res.data;
									  })).catch(error=>{
                                      alert('网络错误');
                                      });										
									}

									}
									else
									{
                                        this.$message({
				                           message: "消费失败,会员业务详情查询失败",
				                          	type: 'error'
						               	 });											
									}

									// console.log(this.ConsumptionData);
								}).catch(error=>{
                                alert('网络错误消费数据获取失败');
                             });
						}
						else
						{
                          this.$message({
				          message: Msg,
				        	type: 'error'
							 });		
						this.inputIdCard='';
						}
				   }).catch(error=>{
                     alert('网络错误');
                   });
                }         
           },
			ConsumptionBusiness(){
				 this.basicCard='';
				this.inputIdCard='';
				this.inputPhone='';
				this.inputName='';
                this.tableData=[];
                
			  this.focusvalue=true;
               
			  this.Machine=true;
			  this.onCellClick(event);
			},
			formatState: function (row, column) {
				return row.State!=1?'正常':'已撤销'
			},
			formatType: function (row, column) {
				return row.ConsumptionType == 0 ? '次卡' : row.ConsumptionType == 1 ? '月卡' : row.ConsumptionType == 2 ? '年卡': row.ConsumptionType == 3? '充值卡': row.ConsumptionType == 4? '培训卡': row.ConsumptionType == 5?'业主卡':'未知';
			},
			CardType: function (row, column) {
				return row.CardType == 0 ? '次卡' : row.CardType == 1 ? '月卡' : row.CardType == 2 ? '年卡': row.CardType == 3? '充值卡': row.CardType == 4? '培训卡': row.CardType == 5?'业主卡':'未知';
			},

			handleCurrentChange(val) {
				this.page = val;
				this.Consumption();
			},
			//获取用户列表
			Consumption() {
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					CardNumber:this.filters.CardNumber
				};
				this.listLoading = true;
				//NProgress.start();
                // console.log(para);
				OneCardPage(para).then((res) => {					 					
					//前端mock测试
					this.total = res.data.TotleCount;
					this.Consumptions = res.data.Data;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
			//删除
			Cancel: function (index, row) {
				this.$confirm('确认撤销这笔消费吗?', '提示', {
					type: 'warning'
				}).then(() => {

					let State=row.State;
					if(State==1)
					{
						this.$message({
							message: '已撤销不能再次撤销',
							type: 'error'
						});

					}
					else
					{
					  if(row.ConsumptionType==1||row.ConsumptionType==2)
					  {
					    this.$message({
							message: '月卡年卡不存在撤销意义',
							type: 'error'
						});
 
					  }
					  else
					  {
                        this.listLoading = true;
					//NProgress.start();
				     	let para = { id: row.Id };
			      		OneCardCancelConsumption(para).then((res) => {
						this.listLoading = false;
						 let { Success,Msg } = res.data;
						 if(Success)
						 {
						this.$message({
							message: Msg,
							type: 'success'
						});

						 }
						 else
						 {
                          this.$message({
				          message: Msg,
				        	type: 'error'
							 });							
						 }
						//NProgress.done();
						this.Consumption();
				       	});						

					  }

					
					}


				}).catch(() => {

				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					batchRemoveUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.Consumption();
					});
				}).catch(() => {

				});
			}
		}
		,
mounted() {
			this.Consumption();
			this.getshopInfo();
}

}
</script>
<style>
.myClass input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid red;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
	width: 100%;
}

.el-input, .el-input__inner {
    width: 100%;
    display: inline-block;
}
</style>

<style scoped>
  .el-form-item {
    margin-bottom: 22px;
    height: 21px;
    }
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}


</style>



// WEBPACK FOOTER //
// Consumption.vue?5c8794c0